// --------------- TYPES ---------------
import { GetInfluencers, GetInfluencer, ChangeInfluencerStatus } from '../Types'

// --------------- INITIAL STATE ---------------
const INITIAL_STATE = { error: null }

// --------------- REDUCER FUNCTION ---------------
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetInfluencers.REQUEST:
      return {
        ...state,
        isGetInfluencersSuccess: null,
        error: null,
      }
    case GetInfluencers.SUCCESS:
      return {
        ...state,
        isGetInfluencersSuccess: true,
        getInfluencersData: action.payload,
      }
    case GetInfluencers.FAILED:
      return {
        ...state,
        isGetInfluencersSuccess: false,
        error: action.payload,
      }
    case GetInfluencer.REQUEST:
      return {
        ...state,
        isGetInfluencerSuccess: null,
        error: null,
      }
    case GetInfluencer.SUCCESS:
      return {
        ...state,
        isGetInfluencerSuccess: true,
        getInfluencerData: action.payload,
      }
    case GetInfluencer.FAILED:
      return {
        ...state,
        isGetInfluencerSuccess: false,
        error: action.payload,
      }
    case ChangeInfluencerStatus.REQUEST:
      return {
        ...state,
        isChangeInfluencerStatusSuccess: null,
        error: null,
      }
    case ChangeInfluencerStatus.SUCCESS:
      return {
        ...state,
        isChangeInfluencerStatusSuccess: true,
        changeInfluencerStatusData: action.payload,
      }
    case ChangeInfluencerStatus.FAILED:
      return {
        ...state,
        isChangeInfluencerStatusSuccess: false,
        error: action.payload,
      }
    default:
      return state
  }
}
